import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";

import classes from "./variantModal.module.css";

import { toast } from "react-toastify";
import {
  onClose,
  selectVariantModalState,
} from "../../store/variantModalSlice";
import { CustomInput } from "../customInput/CustomInput";
import {
  useAddVariantMutation,
  useDeleteVariantMutation,
  useUpdateVariantMutation,
} from "../../services/mastersVariantMutationSlice";
import { selectMastersVariantState } from "../../store/mastersVariantFilterSlice";
import { FormFieldArray } from "../dynamicForm/formFieldArray/FormFieldArray";
import { FormFieldSpecsArray } from "../dynamicForm/formFieldSpecsArray/FormFieldSpecsArray";
import { FormUploadInput } from "../dynamicForm/formUploadInput/FormUploadInput";

export const VariantModal = () => {
  const { isOpen, variantData } = useSelector(selectVariantModalState);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { isDirty, isValid },
    getValues,
    setValue,
    watch
  } = useForm({
    defaultValues: {
      brand: "",
      model: "",
      ram: "",
      rom: "",
      color: "",
      part_name: "",
      price: "",
      original_price: "",
      product_details: [],
      specifications: [],
      spare_image: ""
    },
  });
  console.log("product_details", variantData?.product_details);

  const inputs = [
    { id: "brand", type: "text", placeholder: "Brand" },
    { id: "model", type: "text", placeholder: "Model" },
    { id: "ram", type: "text", placeholder: "Ram" },
    { id: "rom", type: "text", placeholder: "Rom" },
    { id: "color", type: "text", placeholder: "Color" },
    {
      id: "part_name",
      type: "text",
      placeholder: "Part Name",
    },
    {
      id: "price",
      type: "text",
      placeholder: "Price",
    },
    {
      id: "original_price",
      type: "text",
      placeholder: "Original price",
    },
    {
      id: "product_details",
      type: "dynamic-list",
      placeholder: "Product Details",
    },
    {
      id: "specifications",
      type: "specs-array",
      placeholder__head: "Heading",
      placeholder__value: "Value",

      label: "Specifications",
    },
  ];

  const dispatch = useDispatch();
  const masterVariantState = useSelector(selectMastersVariantState);

  const [updateVariant] = useUpdateVariantMutation();
  const [deleteVariant] = useDeleteVariantMutation();
  const [addVariant] = useAddVariantMutation();

  const spareImageUrl = watch("spare_image");

  console.log("variantData :", masterVariantState);

  const getFilteredInputs = () => {
    const filteredInputs = inputs.filter((input) => {
      if (masterVariantState.category === "spares") {
        return input.id !== "ram" && input.id !== "rom";
      } else if (
        masterVariantState.category === "new_phones" ||
        masterVariantState.category === "open_box"
      ) {
        return (
          input.id !== "part_name" &&
          input.id !== "product_details" &&
          input.id !== "specifications"
        );
      }
      return true; // Render all inputs for other categories
    });
    return filteredInputs;
  };

  const filteredInputs = getFilteredInputs();
  const renderInputComponent = (input) => {
    switch (input.type) {
      case "dynamic-list":
        return (
          <FormFieldArray
            key={input.id}
            name={input.id}
            label={input.placeholder}
            control={control}
            register={register}
          />
        );

      case "specs-array":
        return (
          <FormFieldSpecsArray
            key={input.id}
            name={input.id}
            label={input.label}
            placeholder__head={input.placeholder__head}
            placeholder__value={input.placeholder__value}
            control={control}
            register={register}
            getValues={getValues}
          />
        );

      default:
        return (
          <CustomInput
            key={input.id}
            id={input.id}
            type={input.type}
            placeholder={input.placeholder}
            register={register}
          />
        );
    }
  };

  useEffect(() => {
    if (variantData) {
      const baseReset = {
        brand: variantData.brand || "",
        model: variantData.model || "",
        color: variantData.color || "",
        part_name: variantData.part_name || "",
        price: variantData.price || "",
        original_price: variantData.original_price || "",
        product_details: variantData.product_details || [],
        specifications: variantData.specifications || [],
        spare_image: variantData.spare_image || "",
      };

      if (masterVariantState.category !== "spares") {
        baseReset.ram = variantData.ram || "";
        baseReset.rom = variantData.rom || "";
      }

      reset(baseReset);
    }
  }, [variantData, masterVariantState.category, reset]);

  const submitHandler = async (formData) => {
    if (variantData?.action === "Edit") {
       console.log("Final Form Data ===>", formData);
      const advertisementData = {
        id: variantData.id,
        ...formData,
        category: masterVariantState.category,
      };
      try {
        const response = await updateVariant(advertisementData).unwrap();
        toast.success(response.message.displayMessage);
        handleClose();
      } catch (err) {
        console.error("Failed to update advertisement:", err);
        toast.error(err.data.message.displayMessage);
      }
      console.log("variant", formData);
    } else if (variantData?.action === "Delete") {
      try {
        const response = await deleteVariant({
          id: variantData.id,
          category: masterVariantState.category,
        }).unwrap();
        toast.success(response.message.displayMessage);
        handleClose();
      } catch (err) {
        console.error("Failed to delete advertisement:", err);
        toast.error(err.data.message.displayMessage);
      }
    } else if (variantData?.action === "Add") {
      try {
        console.log(formData);
        const response = await addVariant({
          ...formData,
          category: masterVariantState.category,
        }).unwrap();
        toast.success(response.message.displayMessage);
        handleClose();
      } catch (err) {
        console.error("Failed to add advertisement:", err);
        toast.error(err.data.message.displayMessage);
      }
    }
  };

  const handleClose = () => {
    dispatch(onClose());
  };

  return isOpen ? (
    <motion.div
      onClick={handleClose}
      className={classes.backdrop}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        onClick={(e) => e.stopPropagation()}
        className={classes.box}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: -120 }}
        exit={{ opacity: 0, y: 30 }}
        transition={{ duration: 0.5 }}
      >
        <form onSubmit={handleSubmit(submitHandler)} className={classes.form}>
          <h3 className={classes.form__title}>
            Do You Want To {variantData?.action} ?
          </h3>
          <div className={classes.form__group__box}>
            {filteredInputs.map(renderInputComponent)}
            <FormUploadInput
              id="spare_image"
              label="Spare variant Image"
              uploadType="test"
              extraParams={{
                brand_name: getValues("brand"),
                model_name: getValues("model"),
                part_name: getValues("part_name"),
                color_name: getValues("color"),
                no: "1",
              }}
              url={spareImageUrl}
              onChange={(id, imageUrl) => setValue(id, imageUrl, { shouldValidate: true })}
            />
          </div>

          <div className={classes.buttonGroup}>
            <button
              type="button"
              className={classes.buttonGroup__cancel}
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`
    ${classes.buttonGroup__submit}
    ${variantData?.action === "Delete" ? classes.delete : ""}
    ${variantData?.action === "Add" ? classes.add : ""}
    ${variantData?.action === "Edit" ? classes.edit : ""}
    ${
      variantData?.action === "Edit" && isValid && isDirty
        ? classes.isUpdateActive
        : ""
    }
    ${variantData?.action === "Add" && isValid ? classes.isAddActive : ""}
  `}
              disabled={
                (variantData?.action === "Edit" && (!isDirty || !isValid)) ||
                (variantData?.action === "Add" && !isValid)
              }
            >
              {variantData?.action}
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  ) : null;
};
